import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import StyledButton from "../styledButton/StyledButton";

import styles from "./StyledModal.module.scss";

type StyledModalProps = {
  title: string;
  text?: string;
  open: boolean;
  onClose: () => void;
  onContinue?: () => void;
  closeText?: string;
  continueText?: string;
};

export default function StyledModal({
  title,
  text = "",
  open = false,
  onClose = () => {},
  onContinue = () => {},
  closeText,
  continueText = "",
}: StyledModalProps) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  return (
    <Modal open={open} onClose={() => onClose()} disableAutoFocus>
      <Box sx={style}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.text}>{text}</p>
        <div className={styles.buttonContainer}>
          <StyledButton
            baseClassname={styles.closeButton}
            onClick={() => onClose()}
            text={closeText || "Cancel"}
          />
          {onContinue && (
            <StyledButton
              baseClassname={styles.continueButton}
              onClick={() => onContinue()}
              text={continueText || "Continue"}
            />
          )}
        </div>
      </Box>
    </Modal>
  );
}
